import * as v from 'valibot';

const AccountCreationStatus = v.fallback(
  v.union([
    v.literal('ok'),
    v.literal('login'), // existing email, user is requested to login.
    v.literal('unknown'),
  ]),
  'unknown',
);

export const AccountCreationSchema = v.object({
  status: AccountCreationStatus,
});

export type TAccountCreationStatus = v.Output<typeof AccountCreationStatus>;
